import { MembershipDurationsProps } from "modules/membership_plan/commercial_membership_plan/membership_duration/store/actionType";
import { PackageProps } from "modules/membership_plan/commercial_membership_plan/packages/store/actionType";
import { ClientPayloadProps } from "modules/video/video_detail/store/actionType";

export enum actionTypes {
  FETCH_SPECIAL_OFFER_REQUEST = "FETCH_SPECIAL_OFFER_REQUEST",
  FETCH_SPECIAL_OFFER_SUCCESS = "FETCH_SPECIAL_OFFER_SUCCESS",
  FETCH_SPECIAL_OFFER_FAIL = "FETCH_SPECIAL_OFFER_FAIL",

  CREATE_SPECIAL_OFFER_REQUEST = "CREATE_SPECIAL_OFFER_REQUEST",
  CREATE_SPECIAL_OFFER_SUCCESS = "CREATE_SPECIAL_OFFER_SUCCESS",
  CREATE_SPECIAL_OFFER_FAIL = "CREATE_SPECIAL_OFFER_FAIL",

  UPDATE_SPECIAL_OFFER_REQUEST = "UPDATE_SPECIAL_OFFER_REQUEST",
  UPDATE_SPECIAL_OFFER_SUCCESS = "UPDATE_SPECIAL_OFFER_SUCCESS",
  UPDATE_SPECIAL_OFFER_FAIL = "UPDATE_SPECIAL_OFFER_FAIL",

  UPLOAD_SPECIAL_OFFER_VIDEO_REQUEST = "UPLOAD_SPECIAL_OFFER_VIDEO_REQUEST",
  UPLOAD_SPECIAL_OFFER_VIDEO_SUCCESS = "UPLOAD_SPECIAL_OFFER_VIDEO_SUCCESS",
  UPLOAD_SPECIAL_OFFER_VIDEO_FAIL = "UPLOAD_SPECIAL_OFFER_VIDEO_FAIL",

  DELETE_SPECIAL_OFFER_REQUEST = "DELETE_SPECIAL_OFFER_REQUEST",
  DELETE_SPECIAL_OFFER_SUCCESS = "DELETE_SPECIAL_OFFER_SUCCESS",
  DELETE_SPECIAL_OFFER_FAIL = "DELETE_SPECIAL_OFFER_FAIL",

  RESET_SPECIAL_OFFER = "RESET_SPECIAL_OFFER",
}
export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export const FeaturedVideoFolderId = "02c7b007a70e45cfb31bc6e4d42411ca"
export interface SpecialOfferProps {
    updated_at:string;
    start_date:string;
    end_date:string;
    title:string;
    description:string;
    id:string;
    created_at:string;
    membership_duration_id:string;
    number_of_days:string;
    status:string
    membership_duration:MembershipDurationsProps;
}

export interface CreateSpecialOfferInput {
  status: string;
  title: string;
  description: string;
  start_date: string;
  end_date: string;
  membership_duration_id: string;
  number_of_days: string;
  package_id?:string;
}

export interface SpecialOfferInputError {
  status?: string;
  title?: string;
  description?: string;
  start_date?: string;
  end_date?: string;
  membership_duration_id?: string;
  number_of_days?: string;
  packages_id?:string
}
export interface UploadSpecialOfferVideoInput {
  title: string;
  folder_id: string;
  create_video_id: string;
}

//FetchSpecialOffer
export interface FetchSpecialOfferRequestAction {
  type: actionTypes.FETCH_SPECIAL_OFFER_REQUEST;
}

export interface FetchSpecialOfferSuccessAction {
  type: actionTypes.FETCH_SPECIAL_OFFER_SUCCESS;
  payload: SpecialOfferProps[];
}

export interface FetchSpecialOfferFailureAction {
  type: actionTypes.FETCH_SPECIAL_OFFER_FAIL;
  payload: string;
}
//CreateSpecialOffer
export interface CreateSpecialOfferRequestAction {
  type: actionTypes.CREATE_SPECIAL_OFFER_REQUEST;
}

export interface CreateSpecialOfferSuccessAction {
  type: actionTypes.CREATE_SPECIAL_OFFER_SUCCESS;
  payload: SpecialOfferProps;
}

export interface CreateSpecialOfferFailureAction {
  type: actionTypes.CREATE_SPECIAL_OFFER_FAIL;
  payload: string;
}
//UpdateSpecialOffer
export interface UpdateSpecialOfferRequestAction {
  type: actionTypes.UPDATE_SPECIAL_OFFER_REQUEST;
}

export interface UpdateSpecialOfferSuccessAction {
  type: actionTypes.UPDATE_SPECIAL_OFFER_SUCCESS;
  payload: SpecialOfferProps;
}

export interface UpdateSpecialOfferFailureAction {
  type: actionTypes.UPDATE_SPECIAL_OFFER_FAIL;
  payload: string;
}
//UploadSpecialOfferVideo
export interface UploadSpecialOfferVideoRequestAction {
  type: actionTypes.UPLOAD_SPECIAL_OFFER_VIDEO_REQUEST;
}

export interface UploadSpecialOfferVideoSuccessAction {
  type: actionTypes.UPLOAD_SPECIAL_OFFER_VIDEO_SUCCESS;
  payload: ClientPayloadProps;
}

export interface UploadSpecialOfferVideoFailureAction {
  type: actionTypes.UPLOAD_SPECIAL_OFFER_VIDEO_FAIL;
  payload: string;
}
//DeleteSpecialOffer
export interface DeleteSpecialOfferRequestAction {
  type: actionTypes.DELETE_SPECIAL_OFFER_REQUEST;
}

export interface DeleteSpecialOfferSuccessAction {
  type: actionTypes.DELETE_SPECIAL_OFFER_SUCCESS;
  payload: string;
}

export interface DeleteSpecialOfferFailureAction {
  type: actionTypes.DELETE_SPECIAL_OFFER_FAIL;
  payload: string;
}
export interface ResetSpecialOfferAction {
  type: actionTypes.RESET_SPECIAL_OFFER;
}



export type SpecialOfferActions =
  | FetchSpecialOfferRequestAction
  | FetchSpecialOfferSuccessAction
  | FetchSpecialOfferFailureAction
  | CreateSpecialOfferRequestAction
  | CreateSpecialOfferSuccessAction
  | CreateSpecialOfferFailureAction
  | UpdateSpecialOfferRequestAction
  | UpdateSpecialOfferSuccessAction
  | UpdateSpecialOfferFailureAction
  | UploadSpecialOfferVideoRequestAction
  | UploadSpecialOfferVideoSuccessAction
  | UploadSpecialOfferVideoFailureAction
  | DeleteSpecialOfferRequestAction
  | DeleteSpecialOfferSuccessAction
  | DeleteSpecialOfferFailureAction
  | ResetSpecialOfferAction;
